import { render, staticRenderFns } from "./AllBanner.vue?vue&type=template&id=0c8f720f&"
import script from "./AllBanner.vue?vue&type=script&lang=js&"
export * from "./AllBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports